import GalleryIcon from '@/icons/gallery.svg';
import PreviewIcon from '@/icons/preview.svg';
import { Group, MantineStyleProp } from '@mantine/core';
import { PropsWithChildren } from 'react';

export type PreviewOption = 'gallery' | '3d';
interface PreviewHeaderProps {
  selected: PreviewOption;
  onChanged: (option: PreviewOption) => void;
  is3dAvailable: boolean;
}

const activeBg = 'var(--mantine-color-teal-4)';
const notActiveBg = 'var(--mantine-color-gray-1)';

const PreviewHeaderIcon = ({
  selected,
  children,
  isPlacedOnTheRight,
  onClick
}: {
  selected: boolean;
  isPlacedOnTheRight: boolean;
  onClick: () => void
} & PropsWithChildren) => {
  const borderStyle: MantineStyleProp = isPlacedOnTheRight
    ? { borderTopRightRadius: 20, borderBottomRightRadius: 20 }
    : { borderTopLeftRadius: 20, borderBottomLeftRadius: 20 };
  return (
    <Group
      align='center'
      justify='center'
      style={{
        ...borderStyle,
        backgroundColor: selected ? activeBg : notActiveBg,
        width: 28,
        height: 24,
        cursor: 'pointer',
      }}
      onClick={() => onClick()}
    >
      {children}
    </Group>
  );
};

export function PreviewHeader({
  selected,
  onChanged,
  is3dAvailable,
}: PreviewHeaderProps) {
  return (
    <Group justify='flex-end' gap={0}>
      <PreviewHeaderIcon
        onClick={() => onChanged('gallery')}
        selected={selected === 'gallery'}
        isPlacedOnTheRight={false}
      >
        <GalleryIcon
          style={{ marginBottom: 2, cursor: 'pointer' }}
        />
      </PreviewHeaderIcon>
      <PreviewHeaderIcon selected={selected === '3d'} isPlacedOnTheRight={true} onClick={() => (is3dAvailable ? onChanged('3d') : null)}>
        <PreviewIcon
          style={{
            fill: is3dAvailable ? 'none' : 'var(--mantine-color-gray-2)',
            cursor: is3dAvailable ? 'pointer' : 'not-allowed',
          }}
        />
      </PreviewHeaderIcon>
    </Group>
  );
}
